<template lang="pug">
	.creative-detail--iab-categories
		Popup(
			v-if="iabCategories.visible"
			:popupVisible="iabCategories.visible"
			:closeOnOutsideClick="true"
			:width="980", :height="600"
			:title="$tCaption('Iab Categories')"
		)
			.iab-categories-selection
				Loader(v-if="!iabCategories.loaded || iabCategories.applying", :text="$tCaption('Loading', '@actions')", :fullscreen="true")
				template(v-else)
					.flex-row.space-large
						DxTreeList(
							ref="iabCategories"
							:data-source="iabCategories.items"
							:show-borders="false"
							:column-auto-width="true"
							:word-wrap-enabled="true"
							:expanded-row-keys="iabCategories.expandedRowKeys"
							:selected-row-keys="iabCategories.selectedRowKeys"
							:width="400",
							:height="420",
							key-expr="UniqueID"
							parent-id-expr="ParentID"
							@selectionChanged="onIabCategoriesSelectionChanged"
						)
							DxSearchPanel(
								:visible="true",
								:width="320",
								:placeholder="$tCaption('Start typing or scroll through categories below')"
							)
							DxHeaderFilter(:visible="true")
							DxSelection(mode="multiple", :recursive="true")
							DxColumnChooser(:enabled="false")
							DxColumn(:width="320", data-field="Name", :allowSearch="true")

						.flex-col.space
							.iab-spacer
							.font-big.upper.grey {{$tCaption('Creative IAB categories')}}
							.span(v-if="!selectedIABCategories.length") {{$tCaption('Not selected', '@actions')}}
							DxScrollView.flex-1(showScrollbar="always", direction="both", :height="500", width="100%").iab-categories-selected
								.content
									template(v-for="item in selectedIABCategories")
										DxButton.iab-item(
											:text="item.Name",
											icon="close",
											@click="$refs.iabCategories.instance.deselectRows(item.UniqueID)",
											type="success"
										)
			template(slot="actions-right")
				DxButton(:text="$tCaption('Select', '@actions')", @click="applyIabCategories", type="default", :disabled="iabCategories.applying")
				DxButton(:text="$tCaption('Reset', '@actions')", @click="resetIabCategories")
				DxButton(:text="$tCaption('Cancel', '@actions')", @click="cancelIabCategories")
</template>

<script>	
	import Popup from 'app-core/Popup.vue';
	import _ from 'lodash';
	import {
		DxTreeList,
		DxColumn,
		DxColumnChooser,
		DxHeaderFilter,
		DxSearchPanel,
		DxSelection,
		DxLookup
	} from 'devextreme-vue/tree-list';
	import DxScrollView from 'devextreme-vue/scroll-view';
	import DxButton from 'devextreme-vue/button';
	import Loader from 'app-core/Loader.vue';

	export default {
		translationCategory: 'creative.IabCategories',
		name: 'creative-detail--iab-categories',
		props: ['creative', 'editingCreative', 'updateCreative', 'loadCreative'],
		components: {
			Popup, DxTreeList, DxColumn, DxColumnChooser, DxHeaderFilter, DxSearchPanel, DxSelection, DxLookup, DxScrollView, DxButton, Loader
		},

		data() {
			return {
				iabCategories: {
					visible: false,
					loaded: false,
					items: [],
					selected: [],
					screen(width) {
						return (width < 900) ? 'xs' : 'lg';
					},
					expandedRowKeys: [],
					selectedRowKeys: [],
					applying: false
				},
			}
		},
		computed: {
			creativeIabCategories: {
				get() {
					return this.creative?.IabCategories || [];
				},
				set(v) {
					if (__DEBUG__)
						console.log('set creativeIabCategories', v);
				}
			},
			creativeIabCategoriesStr() {
				return this.creativeIabCategories.map(c => c.Name).join(', ') || '-';
			},
			selectedIABCategories() {
				return this.iabCategories.items.filter(f => this.iabCategories.selectedRowKeys.indexOf(f.UniqueID) > -1);
			},
		},
		mounted() {
			this.loadIabCategories();
		},
		methods: {
			openIabCategoriesDialog() {
				this.iabCategories.loaded = false;
				this.iabCategories.visible = true;
				this.iabCategories.selectedRowKeys = (this.editingCreative || this.creative).IabCategories.map(cat => cat.Oid);
				this.iabCategories.loaded = true;
			},
			onIabCategoriesSelectionChanged({ component }) {
				if (__DEBUG__) console.log('Selection changed', component);
				if (!this.iabCategories.loaded) return;
				this.iabCategories.selectedRowKeys = component.getSelectedRowKeys('all').map(r => r.UniqueID || r);
			},
			loadIabCategories() {
				return this.$Data
					.getExternalApi('Service/GetIabCategoriesV2', 9999, void 0, true)
					.then(r => {
						if (__DEBUG__) console.log('Iab Categories loaded', { r });
						this.iabCategories.items = r.map(cat => ({
							UniqueID: cat.Oid,
							ParentID: cat.ParentId || null,
							Name: cat.Name,
							Code: cat.Code,
						}));
					});
			},			
			applyIabCategories() {
				this.creative.IabCategories = this.iabCategories.items
					.filter((item) => this.iabCategories.selectedRowKeys.includes(item.UniqueID))
					.map(f => ({
						Oid: f.UniqueID,
						Name: f.Name,
						Code: f.Code
					}));
				this.iabCategories.applying = true;
				this.updateCreative()
					.then(() => {
						this.loadCreative()
							.then(() => {
								if (this.editingCreative)
									this.editingCreative.IabCategories = _.cloneDeep(this.creative.IabCategories);
							});
						this.cancelIabCategories();
					})
					.finally(() => this.iabCategories.applying = false);
			},
			resetIabCategories() {
				this.iabCategories.selectedRowKeys = [];
			},
			cancelIabCategories() {
				this.resetIabCategories();
				this.iabCategories.visible = false;
			},
		}
	};
</script>
<style lang='scss'>

</style>
